import { supabase } from '../supabase-config';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Helper pour obtenir le token
const getAuthHeaders = async () => {
  const { data: { session } } = await supabase.auth.getSession();
  return {
    headers: {
      Authorization: `Bearer ${session?.access_token || ''}`
    }
  };
};

// ==================== USER OPERATIONS ====================

export const createUserProfile = async (userId, userData) => {
  // Géré par le signup dans AuthContext
  return true;
};

export const getUserProfile = async (userId) => {
  try {
    const { data, error } = await supabase
      .from('users')
      .select('*')
      .eq('id', userId)
      .single();
    
    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error getting user profile:', error);
    throw error;
  }
};

export const updateUserProfile = async (userId, updates) => {
  try {
    const headers = await getAuthHeaders();
    const response = await axios.put(`${API}/auth/profile`, updates, headers);
    return response.data.success;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

// ==================== GAME OPERATIONS ====================

export const createGame = async (userId, gameData) => {
  // Les jeux sont créés automatiquement par le backend via GET /api/games
  // Cette fonction n'est plus nécessaire mais gardée pour compatibilité
  console.log('createGame called - games are auto-created by backend');
  return null;
};

export const getUserGames = async (userId) => {
  try {
    const headers = await getAuthHeaders();
    const response = await axios.get(`${API}/games`, headers);
    return response.data.games || [];
  } catch (error) {
    console.error('Error getting games:', error);
    throw error; // Propager l'erreur au lieu de retourner []
  }
};

export const updateGame = async (gameId, updates) => {
  try {
    const headers = await getAuthHeaders();
    // Utiliser l'endpoint toggle ou update selon le cas
    if ('is_active' in updates) {
      // Pour activer/désactiver, utiliser toggle
      const gameType = gameId.includes('wheel') ? 'wheel' : 'promo';
      await axios.post(`${API}/game/toggle`, {
        game_type: gameType,
        is_active: updates.is_active
      }, headers);
    } else {
      // Pour les autres mises à jour (settings, etc.)
      await axios.put(`${API}/games/${gameId}/settings`, updates, headers);
    }
    return true;
  } catch (error) {
    console.error('Error updating game:', error);
    throw error;
  }
};

export const getGame = async (gameId) => {
  try {
    const { data, error } = await supabase
      .from('games')
      .select('*')
      .eq('id', gameId)
      .single();
    
    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error getting game:', error);
    return null;
  }
};

// ==================== CUSTOMER OPERATIONS ====================

export const createCustomer = async (customerData) => {
  try {
    const { data, error } = await supabase
      .from('customers')
      .insert(customerData)
      .select()
      .single();
    
    if (error) throw error;
    return data.id;
  } catch (error) {
    console.error('Error creating customer:', error);
    throw error;
  }
};

export const getUserCustomers = async (userId) => {
  try {
    const headers = await getAuthHeaders();
    const response = await axios.get(`${API}/customers`, headers);
    return response.data || [];
  } catch (error) {
    console.error('Error getting customers:', error);
    return [];
  }
};

export const deleteCustomer = async (customerId) => {
  try {
    const headers = await getAuthHeaders();
    await axios.delete(`${API}/customers/${customerId}`, headers);
    return true;
  } catch (error) {
    console.error('Error deleting customer:', error);
    throw error;
  }
};

// ==================== GAME SETTINGS OPERATIONS ====================

export const updateGameSettings = async (userId, gameType, settings) => {
  try {
    const { error } = await supabase
      .from('games')
      .update({ game_settings: settings })
      .eq('user_id', userId)
      .eq('game_type', gameType);
    
    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Error updating game settings:', error);
    throw error;
  }
};

export const getGameSettings = async (userId, gameType) => {
  try {
    const { data, error } = await supabase
      .from('games')
      .select('game_settings')
      .eq('user_id', userId)
      .eq('game_type', gameType)
      .single();
    
    if (error) return {};
    return data?.game_settings || {};
  } catch (error) {
    console.error('Error getting game settings:', error);
    return {};
  }
};

// ==================== CHECK CUSTOMER EXISTS ====================

export const checkCustomerExists = async (userId, phone) => {
  try {
    const { data, error } = await supabase
      .from('customers')
      .select('id')
      .eq('user_id', userId)
      .eq('phone', phone)
      .single();
    
    if (error && error.code !== 'PGRST116') {
      throw error;
    }
    
    return { exists: !!data, customer: data };
  } catch (error) {
    console.error('Error checking customer exists:', error);
    return { exists: false };
  }
};
